import { useSelector } from "react-redux"

export const PolicyDetails = () => {
    const policydetail = useSelector(state => state?.trackPolicyDetails)
    return policydetail
}

export const AppointmentDetails = () => {
    const appointments = useSelector(state => state?.appointmentDetails)
    return appointments
}

export const BookVisitDetails = () => {
    const bookVisitDetails = useSelector(state => state?.bookVisitDetails)
    return bookVisitDetails
}

export const TeleAppointmentDetails = () => {
    const appointments = useSelector(state => state?.teleAppointmentDetails)
    return appointments
}
export const TeleUwDetails = () => {
    const teleUwDetails = useSelector(state => state?.teleUwDetails)
    return teleUwDetails
}